export { default } from "./tabMethodsContainer";
